import { CONTACT_EMAIL } from '../../constants/config';
import { URLS } from '../../constants/urls';
import { LinkButton } from '../Button/LinkButton';
import { UnorderedList } from '../List/List';
import { ListItem } from '../List/ListItem';
import { Title } from '../Title/Title';
import { View } from '../View/View';

export const PrivacyPolicy = () => {
  return (
    <>
      <View as="main" sideVariant="md" className="page" gap="2em" text="body-r">
        <Title variant="headline-l-bold" as="h1">
          PRIVACY POLICY
        </Title>
        <p>
          {`FIREWATCH is a brand and product of Y Media Labs, LLC. This privacy policy will explain how our organization uses the data we collect when you use our website.`}
        </p>
        <Title variant="headline-m" as="h2">
          What data do we collect?
        </Title>
        <p>
          {`Y Media Labs, LLC does not store any personally identifiable information when you interact with the FIREWATCH product. Data that is collected while browsing is limited to information about which portions of the website were visited and the time spent on each portion.`}
        </p>
        <Title variant="headline-m" as="h2">
          How do we collect your data?
        </Title>
        <p>
          {`You directly provide Y Media Labs, LLC with all of the data we collect. We collect and process site usage data when you use or view our website via your browser's cookies.`}
        </p>
        <Title variant="headline-m" as="h2">
          How will we use your data?
        </Title>
        <p>
          {`Y Media Labs, LLC collects site usage data so that we can optimize the product experience.  Y Media Labs, LLC does not sell or transfer personally identifiable information.`}
        </p>
        <Title variant="headline-m" as="h2">
          How do we store your data?
        </Title>
        <p>{`Y Media Labs, LLC does not store any personally identifiable information.`}</p>
        <Title variant="headline-m" as="h2">
          What are your data protection rights?
        </Title>
        <p>
          {`Y Media Labs, LLC would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:`}
        </p>
        <UnorderedList>
          <ListItem>
            <strong>The right to access</strong>
            {` - You have the right to request Y Media Labs, LLC for copies of your personally identifiable information. We may charge you a small fee for this service.`}
          </ListItem>
          <ListItem>
            <strong>The right to rectification</strong>
            {` - You have the right to request that Y Media Labs, LLC correct any information you believe is inaccurate. You also have the right to request Y Media Labs, LLC to complete information you believe is incomplete.`}
          </ListItem>
          <ListItem>
            <strong>The right to erasure</strong>
            {` - You have the right to request that Y Media Labs, LLC delete your personally identifiable information, under certain conditions.`}
          </ListItem>
          <ListItem>
            <strong>The right to restrict processing</strong>
            {` - You have the right to request that Y Media Labs, LLC restrict the processing of your personally identifiable information, under certain conditions.`}
          </ListItem>
          <ListItem>
            <strong>The right to object to processing</strong>
            {` - You have the right to object to Y Media Labs, LLC's processing of your personally identifiable information, under certain conditions. `}
          </ListItem>
          <ListItem>
            <strong>The right to data portability</strong>
            {` - You have the right to request that Y Media Labs, LLC transfer the data that we have collected to another organization, or directly to you, under certain conditions.`}
          </ListItem>
        </UnorderedList>
        <p>
          {`If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us at our email:`}
          <LinkButton
            href={`mailto:${CONTACT_EMAIL}`}
            target={CONTACT_EMAIL}
            underline
          >
            {CONTACT_EMAIL}
          </LinkButton>
          <br />
          {`Or write to us:`}
          <br />
          {`Y Media Labs LLC`}
          <br />
          {`255 Shoreline Drive`}
          <br />
          {`Redwood City, California 94605`}
        </p>
        <Title variant="headline-m" as="h2">
          What are cookies?
        </Title>
        <p>
          {`Cookies are text files placed on your computer to collect standard Internet log information and visitor behavior information. When you visit our websites, we may collect information from you automatically through cookies or similar technology.`}
          <br />
          {`For further information, visit `}
          <LinkButton
            href={URLS.ALL_ABOUT_COOKIES}
            target={URLS.ALL_ABOUT_COOKIES}
            underline
          >
            {URLS.ALL_ABOUT_COOKIES}
          </LinkButton>
        </p>
        <Title variant="headline-m" as="h2">
          How do we use cookies?
        </Title>
        <p>
          {`Y Media Labs, LLC uses cookies in a range of ways to improve your experience on our website, including:`}
        </p>
        <UnorderedList>
          <ListItem>Understanding how you use our website</ListItem>
        </UnorderedList>
        <Title variant="headline-m" as="h2">
          What types of cookies do we use?
        </Title>
        <p>
          {`There are a number of different types of cookies, however, our website uses:`}
        </p>
        <UnorderedList>
          <ListItem>
            Functionality - Y Media Labs, LLC uses these cookies so that we recognize
            you on our website and remember your previously selected preferences.
            These could include what language you prefer and location you are in. A
            mix of first-party and third-party cookies are used.
          </ListItem>
          <ListItem>
            Statistics - Y Media Labs, LLC uses these cookies to collect information
            about how you use our website, like which pages you visited and which
            links you clicked on. None of this information can be used to identify
            you. It is all aggregated and, therefore, anonymized. Their sole purpose
            is to improve website functions. This includes cookies from Google
            Analytics services for the exclusive use of the owner of the website
            visited (firewatch.fund).
          </ListItem>
        </UnorderedList>
        <Title variant="headline-m" as="h2">
          How to manage cookies
        </Title>
        <p>
          {`You can set your browser not to accept cookies, and the above website tells you how to remove cookies from your browser. However, in a few cases, some of our website features may not function as a result.`}
        </p>
        <Title variant="headline-m" as="h2">
          Privacy policies of other websites
        </Title>
        <p>
          {`The Y Media Labs, LLC website contains links to other websites. Our privacy policy applies only to our website, so if you click on a link to another website, you should read their privacy policy. Changes to our privacy policy Y Media Labs, LLC keeps its privacy policy under regular review and places any updates on this web page. This privacy policy was last updated on 22 August 2022.`}
        </p>
        <Title variant="headline-m" as="h2">
          How to contact us
        </Title>
        <p>
          {`If you have any questions about Y Media Labs, LLC's privacy policy, the data we hold on you, or you would like to exercise one of your data protection rights, please do not hesitate to contact us.`}
          <br />
          {`Email us at: `}
          <LinkButton
            href={`mailto:${CONTACT_EMAIL}`}
            target={CONTACT_EMAIL}
            underline
          >
            {CONTACT_EMAIL}
          </LinkButton>
          <br />
          {`Or write to us at: `}
          <br />
          {`Y Media Labs LLC`}
          <br />
          {`255 Shoreline Drive`}
          <br />
          {`Redwood City, California 94605`}
        </p>
        <Title variant="headline-m" as="h2">
          How to contact the appropriate authority
        </Title>
        <p>
          {`Should you wish to report a complaint or if you feel that Y Media Labs has not addressed your concern in a satisfactory manner, you may contact the California State Attorney General’s Office.`}
        </p>
      </View>
    </>
  );
};
